"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _doctor = require("@/api/doctor");
var _org = require("@/api/org");
var _doctor_commission = require("@/api/doctor_commission");
var _region = require("@/api/region");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _user = require("@/api/user");
var _file = require("@/api/file");
var _config_diseaseclass = require("@/api/config_diseaseclass");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// secondary package based on el-pagination

var defaultDoctor = {
  // id: '',
  real_name: '',
  doctorname: '',
  dept: null,
  mobile: '',
  // doctor_type: 1, 分表弃用
  sex: '',
  // 1 未知  2 男  3 女
  addrs: '',
  birthdate: null,
  recommender: null,
  province_code: '',
  city_code: '',
  enclosure: '',
  district_code: '',
  recommender_id: '',
  recommender_name: '',
  disease_class: null,
  zip_code: '',
  accounts_name: '',
  accounts_no: '',
  accounts_username: ''
};
var defaultCommission = {
  // id: '',
  doctor: null,
  prescre_type: 1,
  dept: null,
  // treater: null,
  prescre_rate: 0,
  prescre_amount: 0,
  commission_status: null,
  name: ''
};
var phoneValidator = function phoneValidator(rule, value, callBack) {
  var reg = /^[1][0-9]{10}$/;
  if (value) {
    if (!reg.test(value)) {
      callBack('请输入正确的手机号码');
    } else {
      callBack();
    }
  } else {
    callBack();
  }
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      doctor: defaultDoctor,
      doctorData: [],
      userData: [],
      doctorList: {
        count: 0
      },
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 20,
        // doctor_type: 1, 分表弃用
        status: 1 // 1 正常 2 禁用 3 待审核
      },
      statusOptions: [{
        key: 1,
        display_name: '正常'
      }, {
        key: 2,
        display_name: '禁用'
      }, {
        key: 3,
        display_name: '待审核'
      }],
      sexOptions: [{
        key: 2,
        display_name: '男'
      }, {
        key: 3,
        display_name: '女'
      }],
      dialogVisible: false,
      dialogType: 'new',
      rule1: {
        real_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }, {
          max: 10,
          message: '输入长度不能超过10位'
        }],
        doctorname: [{
          required: true,
          message: '请输入登录名',
          trigger: 'blur'
        }, {
          max: 10,
          message: '输入长度不能超过10位'
        }],
        dept: [{
          required: true,
          message: '请选择所属单位',
          trigger: 'change'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }, {
          max: 11,
          message: '输入长度不能超过11位'
        }, {
          validator: phoneValidator
        }],
        sex: [{
          required: true,
          message: '请选择性别',
          trigger: 'change'
        }],
        recommender_id: [{
          required: true,
          message: '请输入推荐人编码',
          trigger: 'blur'
        }],
        recommender_name: [{
          required: true,
          message: '非法人员请重新输入编码',
          trigger: 'blur'
        }],
        disease_class: [{
          required: true,
          message: '请选择科室',
          trigger: 'change'
        }],
        accounts_name: [{
          required: true,
          message: '请输入银行开户行',
          trigger: 'blur'
        }],
        accounts_no: [{
          required: true,
          message: '请输入银行账号',
          trigger: 'blur'
        }],
        accounts_username: [{
          required: true,
          message: '请输入开户人姓名',
          trigger: 'blur'
        }]
        // password: [
        //   { required: true, message: '请输入密码', trigger: 'change' }
        // ],
      },
      filterOrgText: '',
      treeLoding: false,
      orgData: [],
      orgData_origin: [],
      provinceData: [],
      cityData: [],
      defaultCity: [],
      districtData: [],
      defaultDistrict: [],
      // 审核
      dialogSignVisible: false,
      dialogSignType: 'new',
      commission: [],
      listSignLoading: true,
      deptData: {},
      dialogCommissionVisible: false,
      dialogCommissionType: 'new',
      commissionObj: defaultCommission,
      commissionStatusOptions: [{
        key: 1,
        display_name: '比例分成'
      }, {
        key: 2,
        display_name: '固定金额分成'
      }],
      commissionStatusOptionsObj: {
        1: '比例分成',
        2: '固定金额分成'
      },
      rule2: {
        commission_status: [{
          required: true,
          message: '请选择佣金分成类型',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请选择佣金分成对象',
          trigger: 'blur'
        }]
      },
      commissionNameOptions: [],
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)(),
      api: process.env.VUE_APP_BASE_API,
      user_id: '',
      options: [],
      orgData1: []
    };
  },
  computed: {},
  watch: {
    filterOrgText: function filterOrgText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    this.getList();
    this.getOrgAll();
    this.getProvinceAll();
    this.getCityAll();
    this.getDistrictAll();
    this.getUserList();
    this.getDiseaseclass();
    this.getOrg();
  },
  methods: {
    checkPermission: _permission.default,
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      console.log(res.data);
      this.doctor.enclosure = process.env.VUE_APP_BASE_API + res.data.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传封面图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleOrgClick: function handleOrgClick(obj, node, vue) {
      this.listQuery.page = 1;
      this.listQuery.dept = obj.id;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _doctor.getDoctorList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.doctorList = response.data;
          _this.doctorData = (0, _utils.genTree)(response.data.results);
        }
        _this.listLoading = false;
      });
    },
    getUserList: function getUserList() {
      var _this2 = this;
      (0, _user.getUserList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this2.userData = (0, _utils.genTree)(response.data.results);
          console.log(_this2.userData);
        }
      });
    },
    getDiseaseclass: function getDiseaseclass() {
      var _this3 = this;
      (0, _config_diseaseclass.getDiseaseClassAll)().then(function (response) {
        _this3.options = response.data;
      });
    },
    getProvinceAll: function getProvinceAll() {
      var _this4 = this;
      (0, _region.getProvinceAll)().then(function (response) {
        _this4.provinceData = response.data;
      });
    },
    provinceChange: function provinceChange(val) {
      var _this5 = this;
      this.cityData = [];
      this.doctor.city_code = '';
      this.doctor.district_code = '';
      this.defaultCity.forEach(function (item) {
        var item_city = Object.assign({}, item);
        _this5.cityData.push(item_city);
      });
      var province_code = this.provinceData.filter(function (item) {
        return item.id === val;
      })[0].province_code;
      this.cityData = this.cityData.filter(function (item) {
        return item.province_code === province_code;
      });
    },
    getCityAll: function getCityAll() {
      var _this6 = this;
      (0, _region.getCityAll)().then(function (response) {
        _this6.defaultCity = response.data;
        _this6.cityData = [];
        _this6.defaultCity.forEach(function (item) {
          var item_city = Object.assign({}, item);
          _this6.cityData.push(item_city);
        });
      });
    },
    cityChange: function cityChange(val) {
      var _this7 = this;
      this.districtData = [];
      this.doctor.district_code = '';
      this.defaultDistrict.forEach(function (item) {
        var item_district = Object.assign({}, item);
        _this7.districtData.push(item_district);
      });
      var city_code = this.cityData.filter(function (item) {
        return item.id === val;
      })[0].city_code;
      this.districtData = this.districtData.filter(function (item) {
        return item.city_code === city_code;
      });
    },
    getDistrictAll: function getDistrictAll() {
      var _this8 = this;
      (0, _region.getDistrictAll)().then(function (response) {
        _this8.defaultDistrict = response.data;
        _this8.districtData = [];
        _this8.defaultDistrict.forEach(function (item) {
          var item_district = Object.assign({}, item);
          _this8.districtData.push(item_district);
        });
      });
    },
    getOrgAll: function getOrgAll() {
      var _this9 = this;
      this.treeLoding = true;
      (0, _org.getOrgAll)().then(function (response) {
        _this9.orgData_origin = response.data;
        _this9.orgData = (0, _utils.genTree)(response.data);
        _this9.treeLoding = false;
      });
    },
    getOrg: function getOrg() {
      var _this10 = this;
      (0, _org.getDoctorOrg)({
        commission_id: 5
      }).then(function (response) {
        _this10.orgData1 = (0, _utils.genTree)(response.data);
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 20,
        // doctor_type: 1, 分表弃用
        status: 1
      };
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleAddDoctor: function handleAddDoctor() {
      var _this11 = this;
      this.doctor = Object.assign({}, defaultDoctor);
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this11.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(scope) {
        var _this12 = this;
        var province_code, city_code;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.doctor = Object.assign({}, scope.row); // copy obj
              console.log(scope.row.recommender);
              if (!(scope.row.recommender !== null)) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return (0, _user.getUser)(scope.row.recommender).then(function (response) {
                _this12.$set(_this12.doctor, 'recommender_id', response.data.user_id);
                _this12.$set(_this12.doctor, 'recommender_name', response.data.name);
              });
            case 5:
              _context.next = 9;
              break;
            case 7:
              this.$set(this.doctor, 'recommender_id', '');
              this.$set(this.doctor, 'recommender_name', '');
            case 9:
              console.log(this.doctor);
              this.cityData = [];
              if (this.doctor.province_code) {
                province_code = this.provinceData.filter(function (item) {
                  return item.id === _this12.doctor.province_code;
                })[0].province_code;
                this.defaultCity.forEach(function (item) {
                  if (item.province_code === province_code) {
                    var item_city = Object.assign({}, item);
                    _this12.cityData.push(item_city);
                  }
                });
              }
              this.districtData = [];
              if (this.doctor.city_code) {
                city_code = this.cityData.filter(function (item) {
                  return item.id === _this12.doctor.city_code;
                })[0].city_code;
                this.defaultDistrict.forEach(function (item) {
                  if (item.city_code === city_code) {
                    var item_district = Object.assign({}, item);
                    _this12.districtData.push(item_district);
                  }
                });
              }
              this.dialogType = 'edit';
              this.dialogVisible = true;
              this.$nextTick(function () {
                _this12.$refs['Form'].clearValidate();
              });
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleForbidden: function handleForbidden(scope) {
      var _this13 = this;
      this.doctor = Object.assign({}, scope.row);
      this.doctor.status = 2;
      this.$confirm('确认禁用?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _doctor.updateDoctor)(_this13.doctor.id, _this13.doctor);
            case 2:
              _this13.getList();
              _this13.dialogVisible = false;
              _this13.$message({
                type: 'success',
                message: '成功禁用!'
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleRecover: function handleRecover(scope) {
      var _this14 = this;
      this.doctor = Object.assign({}, scope.row);
      this.doctor.status = 1;
      this.$confirm('确认恢复?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _doctor.updateDoctor)(_this14.doctor.id, _this14.doctor);
            case 2:
              _this14.getList();
              _this14.dialogVisible = false;
              _this14.$message({
                type: 'success',
                message: '成功恢复!'
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this15 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _doctor.deleteDoctor)(scope.row.id);
            case 2:
              _this15.getList();
              _this15.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleSign: function handleSign(type, scope) {
      var _this16 = this;
      this.listSignLoading = true;
      this.dialogSignType = type;
      this.commission = [];
      this.dialogSignVisible = true;
      this.deptData = null;
      this.deptData = {
        doctor_id: scope.row.id,
        doctor_name: scope.row.real_name,
        doctor_dept: scope.row.dept,
        dept_data: []
      };
      var dept = scope.row.dept;
      while (dept) {
        var dept_item = this.orgData_origin.filter(function (item) {
          return item.id === dept;
        })[0];
        dept = dept_item.parent;
        if (dept) {
          this.deptData.dept_data.push({
            id: dept_item.id,
            name: dept_item.name
          });
        }
      }
      // console.log('deptData', this.deptData)
      (0, _doctor_commission.getCommissionPrescreList)({
        page: 1,
        page_size: 100,
        doctor: scope.row.id
      }).then(function (res) {
        var commission_data = res.data.results;
        // console.log('lll', commission_data)
        if (commission_data.length === 0) {
          _this16.commission = [];
        } else {
          _this16.commission = commission_data.map(function (item) {
            if (item.dept) {
              item.name = item.dept_name;
            } else {
              item.name = item.doctor_name;
            }
            return item;
          });
          // console.log('xxx', this.commission)
        }
        _this16.listSignLoading = false;
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(form) {
        var _this17 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this17.dialogType === 'edit';
                  delete _this17.doctor.recommender_id;
                  delete _this17.doctor.recommender_name;
                  if (isEdit) {
                    // 移除api domain
                    if (_this17.doctor.enclosure) {
                      _this17.doctor.enclosure = _this17.doctor.enclosure.replace(process.env.VUE_APP_BASE_API, '');
                    }
                    (0, _doctor.updateDoctor)(_this17.doctor.id, _this17.doctor).then(function (res) {
                      _this17.getList();
                      _this17.dialogVisible = false;
                      _this17.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    }).catch(function (error) {
                      console.log(2, error);
                      (0, _user.getUser)(_this17.doctor.recommender).then(function (response) {
                        _this17.$set(_this17.doctor, 'recommender_id', response.data.user_id);
                        _this17.$set(_this17.doctor, 'recommender_name', response.data.name);
                      });
                      console.log(_this17.doctor);
                    });
                  } else {
                    // 移除api domain
                    _this17.doctor.enclosure = _this17.doctor.enclosure.replace(process.env.VUE_APP_BASE_API, '');
                    (0, _doctor.createDoctor)(_this17.doctor).then(function (res) {
                      _this17.getList();
                      _this17.dialogVisible = false;
                      _this17.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    }).catch(function (error) {
                      console.log(2, error);
                      (0, _user.getUser)(_this17.doctor.recommender).then(function (response) {
                        _this17.$set(_this17.doctor, 'recommender_id', response.data.user_id);
                        _this17.$set(_this17.doctor, 'recommender_name', response.data.name);
                      });
                      console.log(_this17.doctor);
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleAddCommission: function handleAddCommission() {
      var _this18 = this;
      this.commissionObj = Object.assign({}, defaultCommission);
      this.commissionNameOptions = null;
      this.commissionNameOptions = [];
      if (!this.commission.filter(function (item) {
        return item.dept === null;
      }).length) {
        this.commissionNameOptions.push({
          dept: null,
          name: this.deptData.doctor_name
        });
      }
      this.deptData.dept_data.forEach(function (dept) {
        if (!_this18.commission.filter(function (item) {
          return item.dept === dept.id;
        }).length) {
          _this18.commissionNameOptions.push({
            dept: dept.id,
            name: dept.name
          });
        }
      });
      // console.log('xxx', this.commissionNameOptions)
      if (!this.commissionNameOptions.length) {
        this.$message({
          type: 'warning',
          message: '没有更多的佣金对象可配置'
        });
      } else {
        this.commissionObj.doctor = this.deptData.doctor_id;
        this.dialogCommissionType = 'new';
        this.dialogCommissionVisible = true;
        this.$nextTick(function () {
          _this18.$refs['CommissionForm'].clearValidate();
        });
      }
    },
    selectNameChange: function selectNameChange(val) {
      this.commissionObj.dept = val;
      this.commissionObj.name = this.commissionNameOptions.filter(function (item) {
        return item.dept === val;
      })[0].name;
    },
    handleEditCommission: function handleEditCommission(scope) {
      var _this19 = this;
      this.commissionObj = Object.assign({}, scope.row);
      if (scope.row.dept) {
        this.commissionObj.name = scope.row.dept_name;
      } else {
        this.commissionObj.name = scope.row.doctor_name;
      }
      this.dialogCommissionType = 'edit';
      this.dialogCommissionVisible = true;
      this.$nextTick(function () {
        _this19.$refs['Form'].clearValidate();
      });
    },
    handleDeleteCommission: function handleDeleteCommission(scope) {
      var _this20 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var index;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return (0, _doctor_commission.deleteCommissionPrescre)(scope.row.id);
            case 2:
              index = null;
              _this20.commission.every(function (value, i) {
                if (value['id'] === scope.row.id) {
                  index = i;
                  return false;
                }
                return true;
              });
              _this20.commission.splice(index, 1);
              _this20.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    selectCommissionTypeChange: function selectCommissionTypeChange() {
      this.commissionObj.prescre_rate = 0;
      this.commissionObj.prescre_amount = 0;
    },
    confirmCommission: function () {
      var _confirmCommission = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7(form) {
        var _this21 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this21.dialogCommissionType === 'edit';
                  if (isEdit) {
                    (0, _doctor_commission.updateCommissionPrescre)(_this21.commissionObj.id, _this21.commissionObj).then(function (res) {
                      (0, _doctor_commission.getCommissionPrescreList)({
                        page: 1,
                        page_size: 100,
                        doctor: _this21.deptData.doctor_id
                      }).then(function (res) {
                        var commission_data = res.data.results;
                        // console.log('lll', commission_data)
                        if (commission_data.length === 0) {
                          _this21.commission = [];
                        } else {
                          _this21.commission = commission_data.map(function (item) {
                            if (item.dept) {
                              item.name = item.dept_name;
                            } else {
                              item.name = item.doctor_name;
                            }
                            return item;
                          });
                          // console.log('xxx', this.commission)
                        }
                        _this21.dialogCommissionVisible = false;
                        _this21.$message({
                          message: '编辑成功',
                          type: 'success'
                        });
                      });
                    });
                  } else {
                    (0, _doctor_commission.createCommissionPrescre)(_this21.commissionObj).then(function (res) {
                      (0, _doctor_commission.getCommissionPrescreList)({
                        page: 1,
                        page_size: 100,
                        doctor: _this21.deptData.doctor_id
                      }).then(function (res) {
                        var commission_data = res.data.results;
                        // console.log('lll', commission_data)
                        if (commission_data.length === 0) {
                          _this21.commission = [];
                        } else {
                          _this21.commission = commission_data.map(function (item) {
                            if (item.dept) {
                              item.name = item.dept_name;
                            } else {
                              item.name = item.doctor_name;
                            }
                            return item;
                          });
                          // console.log('xxx', this.commission)
                        }
                        _this21.dialogCommissionVisible = false;
                        _this21.$message({
                          message: '新增成功',
                          type: 'success'
                        });
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function confirmCommission(_x3) {
        return _confirmCommission.apply(this, arguments);
      }
      return confirmCommission;
    }(),
    confirmSign: function confirmSign() {
      var _this22 = this;
      (0, _doctor.updateDoctor)(this.deptData.doctor_id, {
        status: 1
      }).then(function (res) {
        _this22.getList();
        _this22.dialogSignVisible = false;
        _this22.$message({
          message: '审核成功',
          type: 'success'
        });
      });
    },
    getSaleName: function getSaleName() {
      var _this23 = this;
      console.log(this.doctor.recommender_id);
      if (this.doctor.recommender_id) {
        (0, _user.getUserList)({
          user_id: this.doctor.recommender_id
        }).then(function (response) {
          if (response.data.count === 1) {
            _this23.$set(_this23.doctor, 'recommender', response.data.results[0].id);
            _this23.$set(_this23.doctor, 'recommender_name', response.data.results[0].username);
          } else {
            _this23.$set(_this23.doctor, 'recommender', '');
            _this23.$set(_this23.doctor, 'recommender_name', '');
          }
        });
      } else {
        this.$set(this.doctor, 'recommender', '');
        this.$set(this.doctor, 'recommender_name', '');
      }
      console.log(this.doctor);
    }
  }
};